import { render, staticRenderFns } from "./UploadItem.vue?vue&type=template&id=efa45c4c&scoped=true"
import script from "./UploadItem.vue?vue&type=script&lang=js"
export * from "./UploadItem.vue?vue&type=script&lang=js"
import style0 from "./UploadItem.vue?vue&type=style&index=0&id=efa45c4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa45c4c",
  null
  
)

export default component.exports